import { render, staticRenderFns } from "./OthersGold.vue?vue&type=template&id=4e55d3f2&scoped=true&"
import script from "./OthersGold.vue?vue&type=script&lang=js&"
export * from "./OthersGold.vue?vue&type=script&lang=js&"
import style0 from "./OthersGold.vue?vue&type=style&index=0&id=4e55d3f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e55d3f2",
  null
  
)

export default component.exports